import { MinSecTime } from '../../models/time';

/**
 * Helper to convert millisecond into MinutesSeconds Time
 */
export const convertMillisecToTime = (milliseconds: number): MinSecTime => ({
  minutes: Math.trunc(milliseconds / 60000),
  seconds: (milliseconds / 1000) % 60,
});
